export default __webpack_public_path__ + "static/media/AvenirNext-Regular.4ff6d518.woff";